var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showError
    ? _c(
        "div",
        { staticClass: "error-notification" },
        [
          _c(
            "NotificationBlock",
            {
              attrs: {
                state: "warning",
                iconClassName: "icon-warning",
                expanded: _vm.expanded,
                title: _vm.errorMessage
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "btnSlot",
                    fn: function() {
                      return [
                        _c("ButtonClassic", {
                          attrs: { variant: "primary", labelText: "Close" },
                          on: { click: _vm.onClearError }
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2877946991
              )
            },
            [_c("div", [_c("div", [_vm._v(_vm._s(_vm.errorDetails))])])]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }